import { get } from 'lodash'
import UAParser from 'ua-parser-js'

const uaParser = require('ua-parser-js')
const ua = window.navigator.userAgent
const agent = uaParser(ua)

/**
 * utils/common에서 사용하기 위해 객체 형태로 추가
 */
export const uaInfo = new UAParser(ua)

export const isMobileSafari = () => {
  return agent.browser.name === 'Mobile Safari'
}

export const getType = () => {
  return get(agent, ['device', 'type'], '')
}

export const isMobileDevice = () => {
  return getType() === 'mobile'
}

export const isNaverBrowser = () => {
  return get(agent, 'ua', '').toLowerCase().indexOf('naver') > -1
}

export const isTablet = () => {
  return getType() === 'tablet'
}

export const isIos13IPad = () => {
  const matched = navigator.userAgent.match(/Mac|MacIntel/)
  return matched && matched.length > 0 && navigator.maxTouchPoints > 2
}

export const isIE = () => {
  return agent.browser.name.toUpperCase() === 'IE'
}
